<ion-header class="ion-no-border"> 
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-title>Settings</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-list class="settings-list" *ngIf="user && (user.settingsControl == 1 ||  user.administrator == 1)">
    <div *ngFor="let p of pages"  class="option-container">
        <div class="setting-option" [routerLink]="p.url" routerDirection="root">
          <div class="icon-container">
            <ion-icon name={{p.icon}} class="setting-icon"></ion-icon>
          </div>
          <div class="text-container">
            <h3 class="label">{{p.title}}</h3>
            <p class="info">{{p.info}}</p>
          </div>
        </div>
    </div>
  </ion-list> 

  <ion-list *ngIf="user && user.settingsControl == 0">
    <ion-item>
      <ion-label> You don't have permission to modify settings</ion-label>
    </ion-item>
  </ion-list>

</ion-content>
